import styles from './Decorations.module.css';

interface Particle {
  id: number;
  x: number;
  y: number;
  size: number;
  delay: number;
  duration: number;
}

// Seeded random for consistent SSR/client rendering
function seededRandom(seed: number) {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
}

// Round to 2 decimal places for consistent hydration
const round = (n: number) => Math.round(n * 100) / 100;

// Pre-generate particles with seeded random for hydration consistency
const PARTICLES: Particle[] = Array.from({ length: 35 }, (_, i) => ({
  id: i,
  x: round(seededRandom(i * 1) * 100),
  y: round(seededRandom(i * 2 + 100) * 100),
  size: round(2 + seededRandom(i * 3 + 200) * 5),
  delay: round(seededRandom(i * 4 + 300) * 6),
  duration: round(7 + seededRandom(i * 5 + 400) * 9),
}));

export function Decorations() {
  return (
    <div
      className={styles.decorationsContainer}
      aria-hidden="true"
    >
      {/* Ambient floating particles */}
      <div className={styles.particlesContainer}>
        {PARTICLES.map((p) => (
          <div
            key={p.id}
            className={styles.particle}
            style={{
              left: `${p.x}%`,
              top: `${p.y}%`,
              width: `${p.size}px`,
              height: `${p.size}px`,
              animationDelay: `${p.delay}s`,
              animationDuration: `${p.duration}s`,
            }}
          />
        ))}
      </div>

      {/* Ambient light gradients */}
      <div className={styles.ambientLight}>
        <div className={styles.lightOrb} data-position="top-left" />
        <div className={styles.lightOrb} data-position="bottom-right" />
        <div className={styles.lightOrb} data-position="center" />
      </div>

      {/* Grid overlay for depth */}
      <div className={styles.gridOverlay} />
    </div>
  );
}
